'use strict';
const mmWidgets = require('./mm-widgets'),
	teamConfig = require('@mindmup/mindmup-config/src/team-config'),
	teamProviderClass = require('./team-provider-class');
mmWidgets.fn.goldMapSubteamSharingListWidget = function (mapSharingModel) {
	if (!mapSharingModel) {
		throw new Error('invalid-args');
	}
	return mmWidgets.each(this, function () {
		const element = this,
			listContainer = element.find('[data-mm-role~="subteam-list-container"]'),
			template = element.find('[data-mm-role~=subteam-list-template]').detach(),
			onContext = context => {
				listContainer.empty();
				context.sharableSubteams.forEach(subteam => {
					const subtemWidget = template.clone(),
						provider = teamConfig.getAffiliateProvider(subteam.teamId);
					subtemWidget.find('[data-mm-role~="subteam-description"]').text(subteam.description);
					subtemWidget.find('[data-mm-role~="team-provider"]').addClass(teamProviderClass(provider));
					subtemWidget.find('[subteam-share-with-role]').click(function (e) {
						const item = e.currentTarget,
							role = item.getAttribute('subteam-share-with-role');
						mapSharingModel.shareWithSubteam(subteam, role);
					});
					subtemWidget.appendTo(listContainer);
				});
			};
		element.on('enable', () => {
			mapSharingModel.addEventListener('context', onContext);
		});
		element.on('disable', () => {
			listContainer.empty();
			mapSharingModel.removeEventListener('context', onContext);
		});

	});
};
